import React from 'react'
import styles from '../../../css/services/conServices.module.css';

function ProfessionalLicense() {
  return (
      <div className={styles.container}>
          <div className={styles.services}>
              <div>
                  <h1>تقدم هذه الخدمة للشركات الأجنبية التي ترغب في مزاولة
                      <br/>
                      النشاط المهني داخل المملكة في عدة مجالات وباختلاف نسبة
                      <br/>
                      المشاركة وفقاً للتالي:</h1>
                  <p>
                      1.  ا لترخيص المهني بشريك سعودي 
                      <br />
                      2. الترخيص الاستشاري للمكاتب الهندسية
                      <br />
                      3. الترخيص المكاتب المحاماة الأجنبية
                  </p>
              </div>
          </div>
      </div>
  )
}

export default ProfessionalLicense